import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import { SvgLoader, SvgProxy } from "react-svgmt";
import caso, {estructurasTxt} from "../caso";
import {updateDataUser} from "../js/actions/index";
import "./final.scss";

function mapStateToProps(state){
	let notaFinal = (state.login.user && state.login.user.acf && state.login.user.acf.nota_final)?parseInt(state.login.user.acf.nota_final):-1;
	let respuestas = (state.login.user && state.login.user.acf && state.login.user.acf.respuestas)?state.login.user.acf.respuestas:"";
	return{
		notaFinal,
		respuestas,
	};
}
function mapDispatchToProps(dispatch){
	return{
		updateDataUser:(field,value)=>dispatch(updateDataUser({field,value})),
	};
}
class Final extends Component {
	static propTypes = {
		notaFinal:PropTypes.number,
		respuestas:PropTypes.string,
		updateDataUser:PropTypes.func,
	}
	state = {
		atlasActual:-1,
		listo:false,
		respuesta:"",
		activa:"",
		tiempoRestante:60,
		aciertos:-1,
	}
	constructor (props){
		super(props);
		this.recarga();
	}
	recarga = () => {
		this.listaAtlas = [];
		for(var grupoIdx in caso){
			let grupo = caso[grupoIdx];
			let atlasGrupo = [];
			for(var abordajeIdx in grupo.abordajes){
				let abordaje = grupo.abordajes[abordajeIdx];
				for(var recorridoIdx in abordaje.recorrido){
					let recorrido = abordaje.recorrido[recorridoIdx];
					for(var atlasIdx in recorrido.atlas){
						let atlas = recorrido.atlas[atlasIdx];
						atlasGrupo.push({
							titulo:grupo.titulo,
							abordaje:abordaje.titulo,
							atlas:atlas.atlas,
						});
					}
				}
			}
			for(let i = 0; i < 5; i++){
				let numAtlasRandom = Math.floor(Math.random()*atlasGrupo.length);
				let atlasRandom = atlasGrupo.splice(numAtlasRandom,1)[0];
				let atlasSVG = {
					titulo:atlasRandom.titulo,
					atlassrc:atlasRandom.atlas,
					abordaje:atlasRandom.abordaje,
					estructuras:{},
					listaEstructuras:[],
					elegida:"",
					atlas:<SvgLoader key={atlasRandom.atlas} path={"content/eco"+atlasRandom.atlas}>
						<SvgProxy selector="svg" height="100%"/>
						<SvgProxy selector="image" onElementSelected={(node) => {
							let nombre = node.attributes["xlink:href"].value;
							if(nombre.indexOf("/") === -1){
								node.attributes["xlink:href"].value = "content/eco/"+atlasRandom.atlas.substring(0,atlasRandom.atlas.lastIndexOf("/"))+"/"+nombre;
							}
						}}/>
						<SvgProxy selector="path" onElementSelected={ (node)=>{
							if(this.listaAtlas[this.state.atlasActual].listaEstructuras.length === 0){
								let estructuras = {};
								let listaEstructuras = [];
								node.forEach((element)=>{
									let id = element.id.replace(/_\d_/,"").toLowerCase();
									if(!id.endsWith("linea") && id !== "piel" && id !== "tejidoadiposo"){
										listaEstructuras.push(id);
										estructuras[id] = element;
									}
								});
								let elegidaIdx = Math.floor(Math.random()*listaEstructuras.length);
								let elegida = listaEstructuras[elegidaIdx];
								this.listaAtlas[this.state.atlasActual].elegida = elegida;
								this.listaAtlas[this.state.atlasActual].listaEstructuras = listaEstructuras;
								this.listaAtlas[this.state.atlasActual].estructuras=estructuras;
							}else{
								node.forEach((element)=>{
									let id = element.id.replace(/_\d_/,"").toLowerCase();
									if(!id.endsWith("linea")){
										this.listaAtlas[this.state.atlasActual].estructuras[id] = element;
									}
								});
								window.setTimeout(this.update,100);
							}
						}}/>
					</SvgLoader>,
				};
				this.listaAtlas.push(atlasSVG);
			}
		}
		this.reloj = null;
	}

	reset = () => {
		this.recarga();
		this.setState({
			atlasActual:0,
			listo:false,
			respuesta:"",
			activa:"",
			tiempoRestante:60,
			aciertos:-1,
		});
	}

	siguiente = (forzar = false) => {
		window.clearTimeout(this.reloj);
		if(forzar || this.state.respuesta !== "" || window.confirm("No ha elegido una respuesta, ¿Está seguro de querer continuar?")){
			if(this.state.atlasActual >= 0){
				this.listaAtlas[this.state.atlasActual].respuesta = this.state.respuesta;
			}
			if(this.state.atlasActual < this.listaAtlas.length) {
				this.setState({
					atlasActual:this.state.atlasActual+1,
					listo:false,
					respuesta:"",
					tiempoRestante:60,
				});
				if(this.state.atlasActual < this.listaAtlas.length - 1)
					this.reloj = window.setTimeout(this.descuentaTiempo,1000);
			}
		}
	} 
	update = () => {
		if(this.listaAtlas[this.state.atlasActual].listaEstructuras && this.listaAtlas[this.state.atlasActual].listaEstructuras.length > 0){
			let elegida = this.listaAtlas[this.state.atlasActual].estructuras[this.listaAtlas[this.state.atlasActual].elegida];
			elegida.classList.add("marcada");
			this.setState({listo:true});
		}
		else window.setTimeout(this.update,100);
	}
	descuentaTiempo = () => {
		if(this.state.tiempoRestante > 0){
			this.setState({tiempoRestante: this.state.tiempoRestante-1});
			this.reloj = window.setTimeout(this.descuentaTiempo,1000);
		}else{
			this.siguiente(true);
		}
	}
	btnRespuesta(numAtlas,id){
		let clase = "opcion";
		if(id === this.state.respuesta) clase += " on";
		return <div key={numAtlas+"_"+id} className="respuesta" onClick={()=>{
			this.setState({respuesta:id});
		}}><div className={clase}></div><div className="strLabel">{estructurasTxt[id]}</div></div>;
	}
	render(){
		if(this.state.atlasActual >= 0 && this.state.atlasActual < this.listaAtlas.length){
			let atlas = this.listaAtlas[this.state.atlasActual];
			let estructuras = [];
			if(this.listaAtlas[this.state.atlasActual].listaEstructuras && this.listaAtlas[this.state.atlasActual].listaEstructuras.length > 0){
				for(var id in atlas.estructuras){
					estructuras.push(this.btnRespuesta(this.state.atlasActual,id));
				}
			}else {
				estructuras = <p>cargando...</p>;
				window.setTimeout(this.update,100);
			}
			let clase = "normal";
			if(this.state.tiempoRestante < 10) clase = "danger";
			return <div id="final">
				<div id="ejercicios">
					Pregunta {this.state.atlasActual+1} de {this.listaAtlas.length}<br/>
					Tiempo: <div className={clase}>{this.state.tiempoRestante}</div>
				</div>
				<div id="divAtlas">{atlas.atlas}</div>
				<div id="estructuras">
					<h1>{atlas.titulo}</h1>
					<h2>{atlas.abordaje}</h2>
					<p>SELECCIONE LA ESTRUCTURA QUE APARECE EN LA IMAGEN</p>
					{estructuras}
					<div className="btn" onClick={()=>this.siguiente()}>responder</div>
				</div>
			</div>;
		}else if(this.state.atlasActual < 0){

			return(
				<div id="final">
					<h1>EVALUACIÓN FINAL</h1>
					<p>La evaluación final consta de 30 preguntas tipo test, en la que debe reconocer una estructura anatómica que se le indica en el enunciado de cada ejercicio, los atlas se cargarán de forma aleatoria. </p>
					<p>Dispone de 1 minuto como máximo para responder cada pregunta, una vez transcurrido este tiempo dará paso al siguiente ejercicio. </p>
					<p>Se calificará con una puntuación de 1 a 10 siendo 5 el mínimo para para recibir el aprobado.</p>
					<p>Si sale de la web o cierra el navegador los resultados de la evaluación no se guardarán y deberá volver a empezar de nuevo. Los resultados se mostrarán tras finalizar la prueba.</p>
					<p>Puede acceder a la evaluación todas las veces que sea necesario hasta aprobarla, momento en el cual se dará por terminado el curso con su nota definitiva. Posteriormente, podrá acceder libremente a los contenidos contratados durante el periodo de un año. </p>
					{(this.props.notaFinal < 0)?
						<div className="btn" onClick={()=>this.siguiente(true)}>comenzar</div>:
						<><div className="nota">Ha completado el examen final, su mejor nota es: {this.props.notaFinal}</div>
						{
							(this.props.notaFinal < 5)?<div className="btn" onClick={()=>this.reset()}>volver a intentar</div>:<div className="nota">Curso terminado</div>
						}</>
					}
				</div>
			);
		}else if(this.state.atlasActual === this.listaAtlas.length){
			let notaFinal = this.props.notaFinal;
			if(this.state.aciertos < 0){
				let nota = 0;
				let respuestas = "";
				for(var idAtlas in this.listaAtlas){
					let atlas = this.listaAtlas[idAtlas];
					if(atlas.respuesta === atlas.elegida) nota ++;
					respuestas += "{atlas:'"+atlas.atlassrc+"',respuesta:'"+atlas.respuesta+"',elegida:'"+atlas.elegida+"'},";
				}
				respuestas = this.props.respuestas+"{respuestas:["+respuestas+"]},";
				this.props.updateDataUser("respuestas",respuestas);
				this.setState({aciertos:nota});
			}
			let nota = Math.round((this.state.aciertos/this.listaAtlas.length) * 10);
			if(nota > this.props.notaFinal){
				this.props.updateDataUser("nota_final",nota);
				notaFinal = nota;
			}
			
			return <div id="final">
				<h1>FINALIZADO</h1>
				<div className="nota">Ha completado el examen final.</div>
				<div className="nota">Aciertos {this.state.aciertos} de 30</div>
				<div className="nota">Nota final {(nota === notaFinal)?notaFinal:nota+" no supera la nota "+notaFinal}</div>
				{
					(notaFinal < 5)?<div className="btn" onClick={()=>this.reset()}>volver a intentar</div>:<div className="nota">Curso terminado</div>
				}
			</div>;
		}else {
			return <div id="final">
				<h1>FINALIZADO</h1>
				
			</div>;
		}
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(Final);